import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Picture from '../../atoms/cms-picture';
import Ruler from '../../atoms/ruler';

const Wrapper = styled.section`
  display: flex;
  justify-content: space-between;
`;

const Image = styled(Picture)`
  flex: 0 0 auto;
  width: 50%;

  &:nth-of-type(1) {
    padding-right: ${(props) => props.theme.modularScale.base};
  }

  &:nth-of-type(2) {
    padding-left: ${(props) => props.theme.modularScale.base};
  }
`;

const ImageDesktop = styled(Image)`
  display: none;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    display: block;
    padding: 0 ${(props) => props.theme.modularScale.large};
  }
`;

const ImageMobile = styled(Image)`
  display: block;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    display: none;
  }
`;

const TwoImage = (props) => (
  <>
    {/* // TODO: handle images */}
    <Wrapper>
      {props.data?.left_image_desktop
      && (
      <>
        <ImageDesktop
          {...props.data.left_image_desktop}
          alt={props.data.left_image_alt}
        />
        <ImageMobile
          {...props.data.left_image_mobile}
          alt={props.data.left_image_alt}
        />
      </>
      )}
      {props.data?.right_image_desktop
      && (
        <>
          <ImageDesktop
            {...props.data.right_image_desktop}
            alt={props.data.right_image_alt}
          />
          <ImageMobile
            {...props.data.right_image_mobile}
            alt={props.data.right_image_alt}
          />
        </>
      )}
    </Wrapper>
    { props.data?.hr && <Ruler /> }
  </>
);

TwoImage.propTypes = {
  data: PropTypes.object.isRequired
};

TwoImage.whyDidYouRender = true;

export default memo(TwoImage);
